import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.66663 4.49996C2.66663 3.48744 3.48744 2.66663 4.49996 2.66663H6.16663C6.44277 2.66663 6.66663 2.89048 6.66663 3.16663C6.66663 3.44277 6.44277 3.66663 6.16663 3.66663H4.49996C4.03972 3.66663 3.66663 4.03972 3.66663 4.49996V11.5C3.66663 11.9602 4.03972 12.3333 4.49996 12.3333H11.5C11.9602 12.3333 12.3333 11.9602 12.3333 11.5V9.83329C12.3333 9.55715 12.5572 9.33329 12.8333 9.33329C13.1094 9.33329 13.3333 9.55715 13.3333 9.83329V11.5C13.3333 12.5125 12.5125 13.3333 11.5 13.3333H4.49996C3.48744 13.3333 2.66663 12.5125 2.66663 11.5V4.49996Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.33329 3.16663C9.33329 2.89048 9.55715 2.66663 9.83329 2.66663H12.8333C13.1094 2.66663 13.3333 2.89048 13.3333 3.16663V6.16663C13.3333 6.44277 13.1094 6.66663 12.8333 6.66663C12.5572 6.66663 12.3333 6.44277 12.3333 6.16663V3.66663H9.83329C9.55715 3.66663 9.33329 3.44277 9.33329 3.16663Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0202 2.97974C13.2154 3.175 13.2154 3.49158 13.0202 3.68685L8.18685 8.52018C7.99158 8.71544 7.675 8.71544 7.47974 8.52018C7.28448 8.32492 7.28448 8.00834 7.47974 7.81307L12.3131 2.97974C12.5083 2.78448 12.8249 2.78448 13.0202 2.97974Z"
      fill="currentColor"
    />
  </SvgIcon>
));
